<div class="loading-overlay" *ngIf="isLoading">
  <div class="loading">
    <div class="effect-1 effects"></div>
    <div class="effect-2 effects"></div>
    <div class="effect-3 effects"></div>
  </div>
  <span class="sr-only">{{ 'APP.LOADING' | translate }}</span>
</div>
